import { CompactUserResponse } from '../account';
import { ProjectServiceResponse } from '../project';

export type TMFeeId = string;

export enum TMFeeType {
  item = 'item',
  itemandlabor = 'itemandlabor',
}
export interface TMFeeResponse {
  id: TMFeeId;
  name: string;
  projectService: ProjectServiceResponse;
  percent: number;
  createdBy: CompactUserResponse;
  isTaxable: boolean;
  feeType: TMFeeType;
}
